<template>
	<div v-if="isLoaded" id="average-rating">
		<v-row v-if="mode === 'large'">
			<v-col cols="6" sm="4" class="text-center">
				<p :class="{ 'white--text': dark === true }">
					학생 총 평점
				</p>
				<v-rating
					class="my-4"
					background-color="yellow darken-2"
					color="yellow darken-2"
					readonly
					dense
					half-increments
					v-model="averageRatings"
				></v-rating>
				<h1
					:class="{
						'white--text': dark === true,
						'black--text': dark === false,
					}"
					class="font-weight-bold"
				>
					{{ averageRatings }} <span class="font-weight-light">/ 5</span>
				</h1>
			</v-col>
			<v-col
				v-if="userDevice === 'desktop'"
				cols="6"
				sm="4"
				class="text-center"
			>
				<p :class="{ 'white--text': dark === true }">
					전체 리뷰수
				</p>
				<v-img
					class="my-4 mx-auto"
					width="30"
					src="@/assets/img/reviews/comment.png"
					alt=""
				></v-img>
				<!-- <i
					class="fa-3x fas fa-comment-dots"
					:class="{
						'yellow--text text--darken-2': dark === true,
						'black--text': dark === false,
					}"
				></i
				> -->
				<h1
					:class="{
						'white--text': dark === true,
						'black--text': dark === false,
					}"
					class="font-weight-bold"
				>
					{{ wonCommaFormat(totalCount) }}
				</h1>
			</v-col>
			<v-col cols="6" sm="4" class="text-center">
				<p class="mb-2" :class="{ 'white--text': dark === true }">평점 비율</p>
				<div class="d-flex align-center justify-center">
					<!-- <p class="small">{{ 5 - i }} Stars</p> -->
					<div
						v-for="(score, i) in scoreGroup"
						:key="`score-group-${i}`"
						style="width: 6px; height: 80px;border-radius:5px;"
						:style="
							`background: linear-gradient(0deg, ${graphColor} 0%, ${graphColor} ${score}%, rgba(243,243,243,1) ${score}%, rgba(243,243,243,1) 100%);margin:0 ${
								userDevice === 'mobile' ? 10 : 14
							}px;`
						"
					></div>
				</div>
				<div class="d-flex align-center justify-center">
					<!-- <p class="small">{{ 5 - i }} Stars</p> -->
					<div
						v-for="i in 5"
						:key="`star-${i}`"
						class="text-center mt-1"
						style="width: 34px;"
					>
						<p class="small" :class="{ 'white--text': dark === true }">
							{{ 6 - i }}점
						</p>
					</div>
				</div>
			</v-col>
		</v-row>
		<v-row v-if="mode === 'small'" align="center" justify="center">
			<v-col cols="6" class="text-center">
				<h1
					:class="{
						'white--text': dark === true,
						'black--text': dark === false,
					}"
					class="font-weight-black pt-1"
					style="font-size:3.3rem;line-height:2rem;"
				>
					{{ averageRatings }}
				</h1>
				<v-rating
					class="mt-5 mb-2"
					background-color="yellow darken-2"
					color="yellow darken-2"
					readonly
					dense
					half-increments
					v-model="averageRatings"
				></v-rating>
				<p
					class="text-caption"
					:class="{
						'white--text': dark === true,
						'black--text': dark === false,
					}"
				>
					based on {{ wonCommaFormat(totalCount) }} ratings
				</p>
			</v-col>
			<v-col cols="6">
				<div
					class="mb-1 d-flex align-center"
					v-for="(score, i) in scoreGroup"
					:key="`score-group-${i}`"
				>
					<p
						:class="{
							'white--text': dark === true,
							'black--text': dark === false,
						}"
						class="text-caption"
					>
						{{ 5 - i }} Stars
					</p>
					<div
						class="ml-3"
						style="width: calc(100% - 60px); height: 6px;border-radius:3px;"
						:style="
							`background: linear-gradient(90deg, rgba(0,155,255,1) 0%, rgba(0,155,255,1) ${score}%, rgba(44,52,62,1) ${score}%, rgba(44,52,62,1) 100%);`
						"
					></div>
				</div>
			</v-col>
		</v-row>
		<v-tooltip bottom v-if="reasonShow">
			<template v-slot:activator="{ on, attrs }">
				<p class="grey--text text--darken-1 text-right small">
					<span v-bind="attrs" v-on="on">
						<i>
							<i class="mr-1 far fa-question-circle"></i> 왜 예약화면에서의
							평점과 이곳의 평점이 다른가요?
						</i>
					</span>
				</p>
			</template>
			<div class="keep-word" style="max-width: 300px;">
				지금 보시는 평점은 튜터의 전체 평점의 평균입니다. 예약 시에는 튜터가
				수업을 지속하면서 쌓인 현재의 실력을 정확하게 반영하고자 최근 2개월 수업
				평점의 평균 점수를 보여드립니다. 따라서 예약 시에 확인하시는 평점과
				이곳에서의 평점 평균이 조금씩 다를 수 있습니다.
			</div>
		</v-tooltip>
	</div>
</template>

<script>
import lessonRatingService from '@/services/lesson-rating'
import format from '@/mixins/format'

export default {
	props: {
		tutorId: {
			type: Number,
			default: null,
		},
		gteCreatedAt: {
			type: String,
			default: null,
		},
		lteCreatedAt: {
			type: String,
			default: null,
		},
		reasonShow: {
			type: Boolean,
			default: false,
		},
		dark: {
			type: Boolean,
			dafuelt: false,
		},
		color: {
			type: String,
			default: 'primary',
		},
		mode: {
			type: String,
			default: 'large',
		},
	},
	data: () => ({
		isLoaded: false,
		ratings: [],
		scoreGroup: [],
	}),
	computed: {
		userDevice() {
			return this.$store.getters.userDevice
		},
		graphColor() {
			return this.color === 'pink' ? 'rgb(251, 192, 45)' : 'rgb(7, 108, 250)'
		},
	},
	created() {
		this.getAverage()
	},
	methods: {
		async getAverage() {
			this.isLoaded = false
			this.ratings = await lessonRatingService.getAverage({
				tutorId: this.tutorId,
				gteCreatedAt: this.gteCreatedAt,
				lteCreatedAt: this.lteCreatedAt,
			})
			this.calculate()
			this.isLoaded = true
		},
		calculate() {
			let score = 0
			let count = 0
			let countArray = [0, 0, 0, 0, 0]
			this.ratings.forEach(rating => {
				score = score + rating.score * rating.count
				count = count + rating.count
				switch (parseInt(rating.score)) {
					case 5 || 4.5:
						countArray[0] = countArray[0] + rating.count
						break
					case 4 || 3.5:
						countArray[1] = countArray[1] + rating.count
						break
					case 3 || 2.5:
						countArray[2] = countArray[2] + rating.count
						break
					case 2 || 1.5:
						countArray[3] = countArray[3] + rating.count
						break
					case 1 || 0.5:
						countArray[4] = countArray[4] + rating.count
						break
				}
			})
			this.scoreGroup = [
				Math.round((countArray[0] / count) * 100),
				Math.round((countArray[1] / count) * 100),
				Math.round((countArray[2] / count) * 100),
				Math.round((countArray[3] / count) * 100),
				Math.round((countArray[4] / count) * 100),
			]
			this.averageRatings = Math.round((score / count) * 100) / 100
			this.totalCount = count
		},
	},
	mixins: [format],
}
</script>

<style>
#average-rating .v-rating--dense .v-icon {
	padding: 0;
}
</style>
